import { apiFetch } from "./apiFetch";
import { Paging } from "./video_platform";

export interface ChatMessage {
  id: string;
  content: string;
  senderId: string;
  senderName: string;
  senderAvatarUrl: string | null;
  timestamp: string;
  isEdited: boolean;
  editedAt: string | null;
}

export interface DeleteMessageResponse {
  id: string;
  deletedBy: string;
  deletedAt: string;
}

export interface ChatMessagesResponse {
  data: ChatMessage[];
  paging: Paging;
}

export const ChatResource = {
  getMeetingChat: (params: {
    meetingId: string;
    limit?: number;
    nextToken?: string;
    search?: string;
    senderIds?: string;
    senderName?: string;
    sortOrder?: "asc" | "desc";
  }) => {
    const { meetingId, ...searchParams } = params;
    return apiFetch<ChatMessagesResponse>(
      `/admin/video-platform/meetings/${meetingId}/chat`,
      { searchParams }
    );
  },

  deleteMessage: (meetingId: string, messageId: string) =>
    apiFetch<DeleteMessageResponse>(
      `/admin/video-platform/meetings/${meetingId}/chat/${messageId}`,
      { method: "DELETE" }
    ),
};
